import React from 'react';
import { Divider, Typography } from '@mui/material';
import pahariKrishi from '../../../../../images/Agri-info/crops/pahari_kreshi_পাহাড়ী কৃষি.png';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const PahariKrishiInfo = () => {

    // dynamic title
    useDocumentTitle("পাহাড়ী কৃষি");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                noWrap
                component="div"
            >
                পাহাড়ী কৃষি
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={pahariKrishi} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>ম্যাথ (MATH)  মডেল কী?</b><br />MATH এর পূর্ণ নাম  Modern Agricultural Tecknology   in The Hi lls. এটি হচ্ছে পাহাড়ী অঞ্চলের উপযোগী চাষাবাদের একটি মডেল।</p>
                            <p className="card-text"><b>এমডেলেরবিশেষত্বকী ?</b><br />
                                - এটি ভূমির ক্ষয়রোধ করে<br />
                                - ভূমির উর্বরতা বাড়ায়<br />
                                - একই জমিতে উন্নত পদ্বতিতে চাষাবাদ করে ফসল উৎপাদন করা যায়<br />
                                - পাহাড়ী কৃষকদের আর্থ-সামাজিক উন্নয়ন ঘটানো সম্ভব<br />
                                - এই মডেলের মাধ্যমে পরিবেশের জন্য ক্ষতিকর জুম চাষ পর্যায়ক্রমে বিলুপ্ত করা সম্ভব</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p><b>বাস্তাবয়নকৌশল </b></p>
                <p>ধাপ-১:  জমি নির্বাচন প্রক্রিয়ার মাধ্যমে ‘জুমি’ ফসলগুলো আবাদের ব্যবস্থা করা</p>
                <p>ধাপ-২:  প্রথম বৃষ্টির পর পরই ‘ম্যাথ’ মডেলের অনুসরণে দ্রুত বর্ধনশীল ফসল যেমন, পেঁপে, কলা; স্বল্প মেয়াদী- পেয়ারা, লেবু, দীর্ঘ মেয়াদী- কাঁঠাল, লিচু, আম, সফেদা, জাম্বুরা, কমলা, জাম ইত্যাদি এবং বনজ গাছ ‘জুম’ ক্ষেতে একই সময়ে রোপন করা</p>
                <p>ধাপ-৩:  ধান, ভুট্টা, কাউন ও তেল সংগ্রহের পর পাহাড়ের ঢালভেদে ‘জুম’ ক্ষেতের মধ্যে আড়াআড়িভাবে সারিতে ( Strip Cultivation)  আনারস, অড়হর এসব ফসল বপন/রোপণ করা</p>
                <p>ধাপ-৪: সময়ভেদে ‘জুমি’ ফসল সংগ্রহের পর পর মৌসুম ভিত্তিক (কচু, ঢেঁড়স, বরবটি, টমেটো, বেগুন, মরিচ) ইত্যাদি ফসলের আবাদ করা</p>
                <p>ধাপ-৫: সবজি চাষের পাশাপাশি জমি পরিষ্কার করে ‘আচ্ছাদন ফসল (Cover Coop)’  আবাদ করা</p>
                <p>ধাপ-৬: ‘ম্যাথ’ এর আওতায় উৎপাদিত কৃষি পণ্য কৃষক সমিতি গঠন করে Central Procurement  and Distribution Point (CPDP)  এর মাধ্যমে বাজারজাত করা  </p>
                <p>ধাপ-৭: মৃত্তিকা সস্পদ উন্নয়ন ইনস্টিটিউট কর্তৃক তিন ভাগে বিভক্ত পাহাড়ের ১ম ও ২য় শ্রেণীর পাহাড়ের বেলায় ম্যাথ মডেলটি প্রযোজ্য। অন্যথায় যেখানে ‘জুম’ আছে সেখানেই উক্ত মডেল কার্যকর হবে।</p>

                <p className="card-text"><b>‘ম্যাথ’ মডেলের উপকারিতা</b><br />
                    - পাহাড়ী ভূমির সর্বোচ্চ ভূমি নিশ্চিত করা যায়<br />
                    - একই জমিতে বহু ফসল উৎপাদনের মাধ্যমে ভূমির উর্বরতা বৃদ্ধি ও মাটির ক্ষয় রোধ করা যায়<br />
                    - শস্য পর্যায় ( Coop rotation)  অবলম্বনের মাধ্যমে ভূমির উর্বরতা বৃদ্ধি করে ও মাটির ক্ষয়রোধ করে<br />
                    - স্থায়ীভাবে বনায়ন সৃষ্টির মাধ্যমে প্রাকৃতিক বিপর্যয় রোধ করা C P D P মাধ্যমে উৎপাদিত পণ্যের সমবায় ভিত্তিক বাজারজাতকরণ করা যায়<br />
                    - পর্যায়ক্রমে এ মডেল বাস্তবায়ন হলে পাহাড়ী অঞ্চলে ‘জুম’ চাষ বিলুপ্ত হবে<br />
                    - সর্বোপরি পাহাড়ী এলাকায় ফসলের ফলন বৃদ্ধি পাবে মাটির ক্ষয়রোধ  হবে, আর্থ-সামাজিক উন্নয়ন সম্ভব হবে ও প্রাকৃতিক ভারসাম্য রক্ষা পাবে। </p>

            </div>
        </div >

    );
};

export default PahariKrishiInfo;